import { render, staticRenderFns } from "./Voting.vue?vue&type=template&id=13ec101f&scoped=true"
import script from "./Voting.vue?vue&type=script&lang=ts"
export * from "./Voting.vue?vue&type=script&lang=ts"
import style0 from "./Voting.vue?vue&type=style&index=0&id=13ec101f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ec101f",
  null
  
)

export default component.exports